import SortOrderSwitcher from './SortOrderSwitcher';
import SortOrderSwitcherContainer, {
  OwnProps,
} from './SortOrderSwitcher.container';

export default SortOrderSwitcherContainer(
  SortOrderSwitcher
) as React.ComponentType<OwnProps>;
